/**
 * Service for company API calls
 */
import { apiClient } from "./Api";
import axios from "axios";

export async function getAnalyticsData(companyId: number, dates: object, productId: number) {
  // API is defined by AWS Gateway and is a trigger for a lambda function so a bit different than the other API calls
  // console.log(import.meta.env.VITE_ANALYTICS_API_URL);
  const dateRange = JSON.stringify(dates);
  const apiUrl = import.meta.env.VITE_ANALYTICS_API_URL + "/analytics-data";
  const url = `${apiUrl}?companyId=${companyId}&dateRange=${dateRange}` + 
            (productId !== -1 ? `&productId=${productId}` : "");
  // console.log('Fetching analytics data from URL:', url);
  try {
    const { data } = await axios.get(url);
    return data;
  } catch (error) {
    console.error('Error fetching analytics data:', error);
    return {};
  }
}

export async function getProductViewsAbTest(companyId: number, dates: object, productId: number) {
  const dateRange = JSON.stringify(dates);
  const apiUrl = import.meta.env.VITE_ANALYTICS_API_URL + "/analytics-data-abtest";
  const url = `${apiUrl}?companyId=${companyId}&dateRange=${dateRange}` +
              (productId !== -1 ? `&productId=${productId}` : "");
  const { data } = await axios.get(url);
  return data;
}

export async function fetchProductLinkResults(companyId: number, dates: object, productLinkId: number) {
  if(!companyId){
    return;
  }
  const dateRange = JSON.stringify(dates);

  if(productLinkId === -1){
    const { data } = await apiClient.get(
      `/api/companies/${companyId}/productLinkResults?dateRange=${dateRange}`);
    return data;
  } else if (productLinkId > 0) {
    const { data } = await apiClient.get(
      `/api/companies/${companyId}/productLinkResults/${productLinkId}?dateRange=${dateRange}`);
    return data;
  }
}

// TODO pull product views between the start date of AB Testing and the current date. User turns off there 
// TODO is no end date other than the current date. 
